import {
  Box,
  Button,
  Input,
  Select,
  Table,
  TableContainer,
  Tbody,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";

const CreateTable = ({
  head,
  rows,
  data,
  pagging,
  searchby,
  subcategories,
}) => {
  // Initialize page from URL parameters
  const getInitialPage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const pageParam = urlParams.get("page");
    return pageParam ? parseInt(pageParam, 10) : 1;
  };

  const [page, setPage] = React.useState(getInitialPage);
  const [limit, setLimit] = React.useState(10);
  const [total, setTotal] = React.useState(data?.length > 0 ? data?.length : 0);
  const [search, setSearch] = React.useState("");
  const [sort, setSort] = React.useState(
    searchby && searchby?.length > 0 ? searchby[0] : ""
  );
  const [searchData, setSearchData] = React.useState(data);

  // Update URL when page changes
  const updatePageInURL = (newPage) => {
    const url = new URL(window.location);
    if (newPage > 1) {
      url.searchParams.set("page", newPage.toString());
    } else {
      url.searchParams.delete("page");
    }
    window.history.replaceState({}, "", url);
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    setPage(newPage);
    updatePageInURL(newPage);
  };

  const searchOnChange = (e) => {
    setSearch(e.target.value);

    if (e.target.value === "") {
      setSearchData(data);
      setTotal(data?.length);
      handlePageChange(1);
    }

    const res = data?.filter((item) => {
      return item?.[sort]
        ?.toLowerCase()
        .includes(e.target.value?.toLowerCase());
    });
    setTotal(res?.length);
    handlePageChange(1);
    setSearchData(res);
  };

  // Sync searchData with data when data changes
  React.useEffect(() => {
    if (search === "") {
      setSearchData(data);
      setTotal(data?.length);
    } else {
      // Re-apply search filter with new data
      const res = data?.filter((item) => {
        return item?.[sort]
          ?.toLowerCase()
          .includes(search?.toLowerCase());
      });
      setTotal(res?.length);
      setSearchData(res);
    }
  }, [data]);

  return (
    <Box>
      {searchby && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 3,
            marginBottom: 3,
            marginTop: 3,
          }}
        >
          {" "}
          <Select
            placeholder="Sort"
            onChange={(e) => setSort(e.target.value)}
            value={sort}
          >
            {searchby?.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </Select>
          {sort && sort === "subcategory" ? (
            <Select placeholder="Search" onChange={(e) => searchOnChange(e)}>
              {subcategories?.map((item) => (
                <option key={item?.title} value={item?.title}>
                  {item?.title}
                </option>
              ))}
            </Select>
          ) : (
            <Input placeholder="Search" onChange={(e) => searchOnChange(e)} />
          )}
        </Box>
      )}

      {pagging && (
        <>
          <Text
            fontSize="sm"
            color="gray.500"
            sx={{
              marginTop: 3,
              marginBottom: 3,
            }}
          >
            {`Showing ${page * limit - limit + 1} to ${
              page * limit > total ? total : page * limit
            } of ${total} entries`}
          </Text>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 3,

              paddingBottom: 5,
              overflow: "auto",
            }}
          >
            {new Array(Math?.ceil(total / limit))
              ?.fill(0)
              ?.map((item, index) => (
                <Button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  colorScheme={page === index + 1 ? "blue" : "gray"}
                  variant="solid"
                >
                  {index + 1}
                </Button>
              ))}
          </Box>
        </>
      )}

      <TableContainer>
        <Table variant="striped">
          <Thead>
            <Tr>{head?.map((item) => item && <Th key={item}>{item}</Th>)}</Tr>
          </Thead>
          <Tbody>
            {searchby
              ? searchData
                  ?.slice((page - 1) * limit, page * limit)
                  ?.map((row, index) => (
                    <Tr key={index}>{rows(row, index)}</Tr>
                  ))
              : data?.map((row, index) => (
                  <Tr key={index}>{rows(row, index)}</Tr>
                ))}
          </Tbody>
          <Tfoot>
            <Tr>{head?.map((item) => item && <Th key={item}>{item}</Th>)}</Tr>
          </Tfoot>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CreateTable;
